// extracted by mini-css-extract-plugin
module.exports = {"noResults":"NoResultsWarning_noResults__3QWGa"};